const orgUnitsQueryKeys = {
  all: ['org-units'] as const,
  tree: () => [...orgUnitsQueryKeys.all, 'tree'] as const,
  detail: (id: string) => [...orgUnitsQueryKeys.all, 'detail', id] as const,
};

export default orgUnitsQueryKeys;
